import { useFormContext } from 'react-hook-form';

import CopyComponent from 'components/field/CopyComponent';
import FormItem from 'components/form/FormItem';

import AdvanceSettings from '../AdvanceSettings';
import DeveloperSettings from '../DeveloperSettings';
import BaseSalesChannelForm from '../Forms/BaseSalesChannelForm';
import * as S from '../SalesChannel.styled';

const StoreAdvancedSettingsForm = ({ enumName, showStoreUrl }) => {
	const {
		watch,
		formState: { isSubmitting, isLoading: isFormLoading }
	} = useFormContext();
	const isLoading = isSubmitting || isFormLoading;

	return (
		<S.StoreAccordion header="storeDetails" defaultVisible>
			<BaseSalesChannelForm isLoading={isLoading}>
				<FormItem label="storeID" isLoading={isLoading}>
					<CopyComponent value={watch('username')} />
				</FormItem>
				{showStoreUrl ? (
					<FormItem label="storeURL" isLoading={isLoading}>
						<CopyComponent value={watch('apiUrl')} />
					</FormItem>
				) : (
					<FormItem label="merchantID" isLoading={isLoading}>
						<CopyComponent value={watch('baseUrl')} />
					</FormItem>
				)}
			</BaseSalesChannelForm>
			<AdvanceSettings fields={['addHour', 'statuses']} isLoading={isLoading} enumName={enumName} />
			<DeveloperSettings
				fields={[
					'token',
					'password',
					'codString',
					'secret',
					'apiUrl',
					'productUrl',
					'ignoreNonCodOnPending',
					'commentKeys',
					'TrackingUrlType',
					'lastUpdateDate',
					'webhookStatus',
					'productUpdateDate'
				]}
				isLoading={isLoading}
			/>
		</S.StoreAccordion>
	);
};

export default StoreAdvancedSettingsForm;
